// Wave 3 (languages), English web-app texts: same shape as languagesApp.nl.ts.
export const appLanguagesEn = {
    title: 'Language',
    settingsBody: 'The language of the app, the tablets and the e-mails',
    welcomeTitle: 'Welcome. Which language do you speak at home?',
    welcomeBody: 'Choose the language of your family. You can always change it later in Settings.',
    continue: 'Continue',
    household: 'Family language',
    householdHint: 'For the app, the tablets and the e-mails. Every family member and every tablet follows this language, unless you choose something else.',
    saved: 'Language saved',
    partial: 'Not everything is translated yet. What is missing is shown in Dutch.',
    digitsTitle: 'Numbers',
    digitsLatin: 'Ordinary digits',
    digitsArabic: 'Arabic digits',
    digitsHint: 'For times and numbers, on the tablets and in the app.',
    overridesTitle: 'A language of their own',
    overridesBody: 'Does someone prefer another language, or is there a tablet in a room? Choose that under Family and under Tablets.',
    overridesOff: 'A language per person or tablet is switched off. Switch it on under Modules.',
    toMembers: 'Go to Family',
    toDevices: 'Go to Tablets',
    sameAsFamily: 'Same as the family ({language})',
    memberLabel: 'Language',
    memberHint: 'For the app and the e-mails of {name}.',
    deviceLabel: 'Language of this tablet',
    deviceHint: 'Handy for a tablet in a room. Otherwise it follows the family.',
    deviceSaved: '{name} now speaks {language}',
    ownLanguage: 'Speaks {language}',
    authLabel: 'Language',
};
//# sourceMappingURL=languagesApp.en.js.map